export const birthdays = {
  title: "Aniversários na Gándara",
  subtitle: "Celebre o aniversário do seu filho/a no nosso espaço natural com atividades únicas e divertidas",
  courseYear: "Ano letivo 2025-2026",
  
  gallery: {
    title: "Momentos de aniversário na Gándara",
    caption: "Um espaço especial para celebrar rodeado de natureza",
    images: [
      {
        src: "/lovable-uploads/patio-recetas-flores.jpg",
        alt: "Crianças desfrutando nos espaços naturais da Gándara"
      },
      {
        src: "/lovable-uploads/corro-plaza-piedra.png",
        alt: "Atividades ao ar livre para aniversários"
      },
      {
        src: "/lovable-uploads/patio-rampa-pales.png",
        alt: "Espaços preparados para celebrações"
      }
    ]
  },
  
  generalInfo: {
    title: "Informação Geral",
    availabilityLabel: "Disponibilidade",
    availability: "Sextas-feiras à tarde, Sábados e Domingos",
    durationLabel: "Duração",
    duration: "3-4 horas",
    description: "Oferecemos um espaço único para celebrar aniversários infantis num ambiente natural e respeitoso. As nossas celebrações são desenhadas para que as crianças desfrutem de uma experiência memorável rodeadas de natureza, com atividades educativas e lúdicas que promovem a criatividade e o jogo livre."
  },
  
  plans: {
    title: "Planos Disponíveis",
    priceNote: "até 15 crianças",
    aTuAire: {
      name: "À Tua Maneira",
      description: "Espaço próprio para a tua celebração",
      features: [
        "Uso das nossas instalações",
        "Acesso a zonas naturais",
        "Sem acompanhamento educativo"
      ],
      priceSmall: "120€",
      priceLarge: "180€"
    },
    acompanada: {
      name: "Acompanhada",
      description: "Com animador/a profissional",
      features: [
        "Tudo incluído em 'À Tua Maneira'",
        "Animador/a educativo/a",
        "1 workshop dirigido à escolha"
      ],
      priceSmall: "250€",
      priceLarge: "400€"
    },
    experienciaCompleta: {
      name: "Experiência Completa",
      description: "A celebração mais especial",
      badge: "Recomendado",
      features: [
        "Tudo incluído em 'Acompanhada'",
        "2 workshops dirigidos à escolha",
        "Decoração temática",
        "Zona de lanche preparada"
      ],
      priceSmall: "400€",
      priceLarge: "500€"
    }
  },
  
  pricingTable: {
    title: "Tabela de Preços",
    headers: {
      plan: "Plano",
      small: "Até 15 crianças",
      large: "16-30 crianças"
    }
  },
  
  workshops: {
    title: "Workshops Disponíveis",
    items: [
      "Cantos de jogo",
      "Workshop de arte",
      "Pintura facial",
      "Bolhas gigantes",
      "Cozinha criativa",
      "Sensorial",
      "Pulseiras",
      "DIY (Faça você mesmo)"
    ]
  },
  
  extras: {
    title: "Extras Disponíveis",
    items: [
      { name: "Mini-Discoteca", price: "50€" },
      { name: "Lanche para adultos", price: "6€/pessoa" },
      { name: "Limpeza adicional", price: "30€" },
      { name: "Bolo de aniversário", price: "40€" },
      { name: "Workshop adicional", price: "50€" }
    ]
  },
  
  booking: {
    title: "Processo de Reserva",
    deposit: "Depósito",
    depositDescription: "É necessário um depósito de 50€ que será descontado do preço final da celebração.",
    cancellation: "Política de Cancelamento",
    cancellationDescription: "Os cancelamentos devem ser feitos com pelo menos 1 semana de antecedência para reembolso total do depósito."
  },
  
  form: {
    title: "Pedido de Reserva",
    contactSection: "Dados de Contacto",
    birthdaySection: "Dados do Aniversário",
    preferencesSection: "Preferências",
    extrasSection: "Extras (Opcional)",
    
    fields: {
      parentName: "Nome do pai/mãe",
      email: "Email",
      phone: "Telefone",
      childName: "Nome da criança",
      childAge: "Idade da criança",
      numberOfChildren: "Número de crianças convidadas",
      preferredDate: "Data preferida",
      alternativeDate: "Data alternativa (opcional)",
      selectedPlan: "Plano selecionado",
      preferredWorkshops: "Workshops preferidos (máximo 2)",
      adultSnacksCount: "Número de adultos",
      comments: "Comentários adicionais",
      acceptTerms: "Aceito os termos e condições"
    },
    
    placeholders: {
      parentName: "Maria Silva",
      email: "maria@example.com",
      phone: "+34 600 123 456",
      childName: "Nome do aniversariante",
      comments: "Preferências, necessidades especiais... Se alguma criança tiver alergias, indique apenas quais e quantas crianças, sem nomes."
    },
    
    submit: "Enviar pedido de reserva",
    submitting: "Enviando...",
    success: "Pedido enviado com sucesso! Entraremos em contacto em breve.",
    error: "Erro ao enviar o pedido. Por favor, tente novamente."
  },
  
  contact: {
    title: "Tem perguntas?",
    description: "Contacte-nos para mais informações sobre disponibilidade, preços e opções de personalização.",
    emailButton: "Contactar por email"
  }
};
